export type FloatingPanelPosition = Readonly<{
  x: number;
  y: number;
}>;

export type FloatingPanelStorage = "local" | "session";

type FloatingPanelSize = Readonly<{
  width: number;
  height: number;
}>;

function getStorage(kind: FloatingPanelStorage): Storage | null {
  if (typeof window === "undefined") return null;
  return kind === "local" ? window.localStorage : window.sessionStorage;
}

export function loadFloatingPanelPosition(
  key: string,
  storage: FloatingPanelStorage
): FloatingPanelPosition | null {
  try {
    const raw = getStorage(storage)?.getItem(key);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed === "object" &&
      parsed !== null &&
      "x" in parsed &&
      "y" in parsed &&
      typeof parsed.x === "number" &&
      typeof parsed.y === "number" &&
      Number.isFinite(parsed.x) &&
      Number.isFinite(parsed.y)
    ) {
      return { x: parsed.x, y: parsed.y };
    }
  } catch {
    return null;
  }

  return null;
}

export function saveFloatingPanelPosition(
  key: string,
  position: FloatingPanelPosition,
  storage: FloatingPanelStorage
) {
  try {
    getStorage(storage)?.setItem(key, JSON.stringify(position));
  } catch {
    return;
  }
}

export function clampFloatingPanelPosition(
  position: FloatingPanelPosition,
  bounds: FloatingPanelSize,
  panel: FloatingPanelSize,
  gutter: number
): FloatingPanelPosition {
  return {
    x: Math.min(
      Math.max(position.x, gutter),
      Math.max(gutter, bounds.width - panel.width - gutter)
    ),
    y: Math.min(
      Math.max(position.y, gutter),
      Math.max(gutter, bounds.height - panel.height - gutter)
    ),
  };
}
